import { util } from 'pevueglobal'

const state = {
  personalData: {},
  currentUser: {}
}

// getters
const getters = {
  personalData: state => state.personalData,
  currentUser: state => state.currentUser
}

// actions
const actions = {
    getTexten: async ({ dispatch }) => {
    let textIDs = [13, 26, 60, 80, 81, 149, 1052, 2302, 2303, 3178, 8944, 8971, 8973, 9080, 12980, 14377, 15270]
    for (var i = 1434; i <= 1441; i++) {
      textIDs.push(i)
    }
        for (var j = 11914; j <= 11925; j++) {
      textIDs.push(j)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  initPersonalData: async ({ commit, rootState }) => {
    state.currentUser = rootState.currentUser
    const personalData = await util.getDataApi('allroles/PEapi_GetPersonalData')

    mapFromApi(personalData, rootState)

    commit('setPersonalData', personalData)
  },

  submitPersonalData: async ({ commit, rootState }) => {
    mapToApi(state.personalData)
    const result = await util.getDataApi('allroles/PEapi_PersonalData_update', state.personalData)

    mapFromApi(result, rootState)

    commit(
      'addNotification',
      {
        groupname: 'primary',
        message: rootState.translation[149]
      },
      { root: true }
    )
  }
}

// mutations
const mutations = {
  setPersonalData(state, personalData) {
    state.personalData = personalData
  },

  setSendOutOfOfficeNotification(state, option) {
    state.personalData.sendOutOfOfficeNotification = option
  },
 
  setPreferredMfaVerification(state, option) {
    state.personalData.PreferredMfaVerification = option
  },

  setMailNormalFrequence(state, option) {
    state.personalData.mailNormalFrequence = option
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function mapFromApi(personalData, rootState) {
  personalData.buttonStandaardTekstenVisible = false
  personalData.outOfOfficeNotificationAllowed = false
  // Don't initialize because its being determined in the backend.
  // The backend checks in the profgroup tabel in use pin is true + roles check.
  // personalData.usePincodeAllowed = false

  determinePermissions(personalData, rootState)

  if (personalData.outOfOfficeSettings) {
    personalData.outOfOfficeSettings.startDate = new Date(personalData.outOfOfficeSettings.startDate)
    personalData.outOfOfficeSettings.endDate = new Date(personalData.outOfOfficeSettings.endDate)
  } else {
    personalData.outOfOfficeSettings = { startDate: null, endDate: null }
  }
}

function mapToApi(personalData) {
  personalData.outOfOfficeId = personalData.outOfOfficeSettings.outOfOfficeId

  if (personalData.sendOutOfOfficeNotification) {
    personalData.startDate = util.DateForDatabase(personalData.outOfOfficeSettings.startDate)
    personalData.endDate = util.DateForDatabase(personalData.outOfOfficeSettings.endDate)
    personalData.message = personalData.outOfOfficeSettings.message
  }
}

function determinePermissions(personalData, rootState) {
  console.log(rootState)
  console.log(util.UgetCookie('pe_Subroles'))
  // Check if user is allowed to see/click the button
  personalData.buttonStandaardTekstenVisible = rootState.currentUser.containsAnySubrollen([
    '2',
    '3',
    '6',
    '8',
    '11',
    '16',
    '17',
    '19',
    '20',
    '21',
    '26',
    '27',
    '38'
  ])

  // Check if user is allowed to set or change Afwezigheidmeldingen
  // 'Issue 86852; Out Of Office only visible when admin has subrol3 or subrol11 or subrol16.
  personalData.outOfOfficeNotificationAllowed = rootState.currentUser.containsAnySubrollen(['3', '11', '16'])
}
